import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=5bef843c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bef843c')) {
      api.createRecord('5bef843c', component.options)
    } else {
      api.reload('5bef843c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=5bef843c&", function () {
      api.rerender('5bef843c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2r1wU4hEhwa13/JS/comp/ImgFallback.vue"
export default component.exports